import store from '../store';
import convert from 'xml-js';
//import { MassEditItemModel } from '../models/MassEditItemModel';


export default class MassEditConfig {
  constructor(api) {
    this.api = api
  }

  massEditConfigurationItems = [ 
    {id: 1 , name: 'test1'},
    {id: 2 , name: 'test2'},
    {id: 3 , name: 'test3'},
  ]


  // listExportConfig
  list() {
    store.commit('setMassEditConfigurationItems', this.massEditConfigurationItems)
    this.api.call_busy({
      '_class': 'MassEditConfig',
      '_method': 'list',
    }).then(response => {
      let massEditConfigurationItems = []
      response.mass_edit_config = response.mass_edit_config ? (response.mass_edit_config.length ? response.mass_edit_config : [response.mass_edit_config]) : []
      response.mass_edit_config.forEach(mass_edit_config => {
        massEditConfigurationItems.push(mass_edit_config._attributes)
      })
      // NOTE: TBD: add vSelect-specific properties
      massEditConfigurationItems = massEditConfigurationItems.map(a => ({ ...a, value: a.id, text: a.name }))
      massEditConfigurationItems.sort((item1, item2) => {
        return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1
      })
      store.commit('setMassEditConfigurationItems', massEditConfigurationItems)
    })
  }

  // loadExportConfig
  load(id) {
    return this.api.call_busy({
      '_class': 'MassEditConfig',
      '_method': 'load',
      'id': id
    }).then(response => {

      // if (!response.mass_edit_config || !response.mass_edit_config.format || !response.mass_edit_config.format.column) {
      //   return
      // }
      // response.mass_edit_config.format.column = response.mass_edit_config.format.column.length ? response.mass_edit_config.format.column : [response.mass_edit_config.format.column]
      return response
    })
  
    // return new Promise((resolve) => {
    //     let list = []
    //     let item
      
    //     if(id == 1) {
    //       item = new MassEditItemModel()
    //       item.command = {id:"clear", label:"clear", text: "MASSEDIT_ACTION_CLEAR", value:"clear"}
    //       item.field = {datatype:"default", editable: true , field: "title", id:"title" , label: "Title" , mergeable : true , mergeshow : true , settable : true, 
    //       sortable : true , text: "DB_TITLE" , type: "field" , value: "ititle"}
    //       list.push(item)

    //       item = new MassEditItemModel()
    //       item.command = {id:"replace", label:"replace with", text: "MASSEDIT_ACTION_SETTEXT", value:"replace"}
    //       item.field = {datatype:"default", editable: true , field: "lastname", id:"name" , label: "Last name" , mergeable : true , mergeshow : true , settable : true, 
    //       sortable : true , text: "DB_LASTNAME" , type: "field" , value: "iname"}
    //       list.push(item)

    //       item = new MassEditItemModel()
    //       item.command = {id:"replace", label:"replace with", text: "MASSEDIT_ACTION_SETTEXT", value:"replace"}
    //       item.field = {datatype:"default", editable: true , field: "company", id:"company" , label: "Company" , mergeable : true , mergeshow : true , settable : true, 
    //       sortable : true , text: "DB_COMPANY" , type: "field" , value: "icompany"}
    //       list.push(item)

    //       item = new MassEditItemModel()
    //       item.command = {id:"replace", label:"replace with", text: "MASSEDIT_ACTION_SETTEXT", value:"replace"}
    //       item.field = {datatype:"default", editable: true , field: "email", id:"email" , label: "email" , mergeable : true , mergeshow : true , settable : true, 
    //       sortable : true , text: "DB_EMAIL" , type: "field" , value: "iemail"}
    //       list.push(item)
    //     }
    //     else if(id == 2){
    //       item = new MassEditItemModel()
    //       item.command = {id:"replace", label:"replace with", text: "MASSEDIT_ACTION_SETTEXT", value:"replace"}
    //       item.field = {datatype:"default", editable: true , field: "lastname", id:"name" , label: "Last name" , mergeable : true , mergeshow : true , settable : true, 
    //       sortable : true , text: "DB_LASTNAME" , type: "field" , value: "iname"}
    //       list.push(item)

    //       item = new MassEditItemModel()
    //       item.command = {id:"replace", label:"replace with", text: "MASSEDIT_ACTION_SETTEXT", value:"replace"}
    //       item.field = {datatype:"default", editable: true , field: "company", id:"company" , label: "Company" , mergeable : true , mergeshow : true , settable : true, 
    //       sortable : true , text: "DB_COMPANY" , type: "field" , value: "icompany"}
    //       list.push(item)
    //     }
    //     else if(id == 3){
    //       item = new MassEditItemModel()
    //       item.command = {id:"replace", label:"replace with", text: "MASSEDIT_ACTION_SETTEXT", value:"replace"}
    //       item.field = {datatype:"default", editable: true , field: "company", id:"company" , label: "Company" , mergeable : true , mergeshow : true , settable : true, 
    //       sortable : true , text: "DB_COMPANY" , type: "field" , value: "icompany"}
    //       list.push(item)

    //       item = new MassEditItemModel()
    //       item.command = {id:"replace", label:"replace with", text: "MASSEDIT_ACTION_SETTEXT", value:"replace"}
    //       item.field = {datatype:"default", editable: true , field: "email", id:"email" , label: "email" , mergeable : true , mergeshow : true , settable : true, 
    //       sortable : true , text: "DB_EMAIL" , type: "field" , value: "iemail"}
    //       list.push(item)

    //       item = new MassEditItemModel()
    //       item.command = {id:"replace", label:"replace with", text: "MASSEDIT_ACTION_SETTEXT", value:"replace"}
    //       item.field = {datatype:"default", editable: true , field: "lastname", id:"name" , label: "Last name" , mergeable : true , mergeshow : true , settable : true, 
    //       sortable : true , text: "DB_LASTNAME" , type: "field" , value: "iname"}
    //       list.push(item)
    //     }

    //    resolve(list)
     
    //})

    
  }

  // createExportConfig
  create(id, name, jsonObject) {
    const xml = this.buildXml(jsonObject)
    const params = {
      '_class': 'MassEditConfig',
      'xml': xml,
      'name': name
    }
    if (id) {
      params.id = id
      params._method = 'update'
    } else {
      params._method = 'create'
    }
    if (name) {
      params.name = name
    }
   console.log('XML->',xml)
    return this.api.call_busy(params).then(response => {
      // if (!response.mass_edit_config || !response.mass_edit_config.format || !response.mass_edit_config.format.column) {
      //   return
      // }
      // response.mass_edit_config.format.column = response.mass_edit_config.format.column.length ? response.mass_edit_config.format.column : [response.mass_edit_config.format.column]
      this.list()
      return response
    })
  }

  delete(id) {
    return this.api.call_busy({
      '_class': 'MassEditConfig',
      '_method': 'delete',
      'id': id,
    }).then(response => {
      this.list()
      return response
    })
  }

  

  buildXml(jsonObject) {
    const newJson = {
      'request' : {
        'items': []
      }
    }

    newJson.request.items = jsonObject.map(item => ({
      command: {
        _attributes: {
          id: (item.command && item.command.id) ? item.command.id : -1
        }
      } ,
      field: {
        _attributes: {
          id: item.field.id,
          type: item.field.type
        }
      },
      value: item.value
    }))
    return convert.json2xml(newJson, {compact: true})
  }

}
